import React, { useState, useRef } from "react";
import { useHistory, Link } from "react-router-dom";
import {
  Button,
  Modal,
  Backdrop,
  Fade,
  TextField,
} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';

import { useAuth } from "./firebase/AuthContext";
import SignUpModal from "./signup";
import Password from "./forgotPassword";

const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#fff",
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  rounded: {
    borderRadius: "10px",
    border: "none",
  },
}));


const SignInModal = () => {
  const classes = useStyles();

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const { currentUser, login } = useAuth()
  const emailRef = useRef();
  const passwordRef = useRef();
  const history = useHistory();

  const handleOpen = () => {
    if(!currentUser){
      setOpen(true);
    }else{
      history.push("/workspace")
    }
  };

  const handleClose = () => {
    setOpen(false);

  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setError("");
      setLoading(true);
      await login(emailRef.current.value, passwordRef.current.value);
      history.push("/workspace")
      handleClose();
    } catch {
      setError("Incorrect email or password.");
    }

    setLoading(false);
  };


    return (
      <div>
        
        <Button  onClick={handleOpen} style={{paddingRight: '30px'}}>
          Sign in
        </Button>
        <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Fade in={open}>
        <div className={`${classes.paper} ${classes.rounded}`}>
          <h2 id="transition-modal-title">Sign In</h2>
          <h5 style={{color: 'red'}}>{error}</h5>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            onSubmit={handleSubmit}
          >
            <TextField
              id="email"
              label="Email"
              inputRef={emailRef}
              required
              sx={{
                "& fieldset": {
                  border: "none",
                }
              }}
              InputProps={{
                style: {
                  width: "420px",
                  fontFamily: "'inter",
                  fontStyle: "normal",
                  fontWeight: 700,
                  fontSize: "20px",
                  color: `grey`,
                  margin: '20px',
                  textAlign: "center",
                  "&::placeholder": {
                    textAlign: "center"
                  }
                }
              }}
            />
            <TextField
              inputRef={passwordRef}
              required
              id="Password"
              label="Password"
              type="password"
              sx={{
                "& fieldset": {
                  border: "none",
                }
              }}
              InputProps={{
                style: {
                  width: "420px",
                  fontFamily: "'inter",
                  fontStyle: "normal",
                  fontWeight: 700,
                  fontSize: "20px",
                  color: `grey`,
                  margin: '20px',
                  textAlign: "center",
                  "&::placeholder": {
                    textAlign: "center"
                  }
                }
              }}
            />
            <Button style={{ backgroundColor: '#7E3AF2', color: 'white', fontFamily: 'Inter', marginBottom: '10px' }} disabled={loading} type="submit">
              Submit
            </Button>
          </form>
          <div style={{ paddingTop:'60px'}}>
            <Password />
          </div>
        </div>
      </Fade>
    </Modal>
      </div>
    );

};

export default SignInModal;